import React from 'react';

import styles from './Button.module.scss'

const Button = props => (
    <button type={props.type} className={styles.roundButton} disabled={props.disabled} onClick={props.onClick} style={{'width' : props.width}} > {props.title} </button>
);

export default Button;